module.exports = __webpack_public_path__ + "img/冰淇淋车男孩.d3ea3ae9.png";